import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Line, Merchandise } from 'src/app/shop/models/cart.model';
import * as fromShopify from '../../../shop';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Analyzify } from 'src/app/utility/analyzify.utility';
import { CookiePreferences } from '@teamfoster/sdk/cookie-ngrx';

@Component({
  selector: 'app-cart-product-line',
  templateUrl: './cart-product-line.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CartProductLineComponent implements OnInit {
  private fb = inject(FormBuilder);
  private _line!: Line;

  @Input() set line(value: Line) {
    this._line = value;
    this.amountField?.setValue(this.line.quantity);
  }

  get line() {
    return this._line;
  }
  @Input() cartLoading: boolean = true;
  @Input() linesLoading: string[] = [];
  @Input() cookiePrefs?: CookiePreferences | null;

  amountField!: FormControl;

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.amountField = this.fb.control(this.line?.quantity, [
      Validators.required,
      Validators.max(this.getMaxQuantity(this.line.merchandise)),
      Validators.min(1),
    ]);
  }

  changeQuantity(newQuantity: number, lineId: string, oldQuantity: number) {
    if (this.cookiePrefs?.marketing) {
      const delta = newQuantity - oldQuantity;
      if (delta < 0) {
        Analyzify.RemoveFromCart(this.line, Math.abs(delta));
      } else {
        Analyzify.AddItemToCart(this.line, newQuantity);
      }
    }
    this.store.dispatch(fromShopify.UpdateCartLine({ lineId, quantity: newQuantity }));
  }

  removeProduct(lineId: string) {
    if (this.cookiePrefs?.marketing) {
      Analyzify.RemoveFromCart(this.line);
    }
    this.store.dispatch(fromShopify.DeleteCartLine({ lineId }));
  }

  getUnit(line: Line) {
    return line.merchandise.product.metafield?.value;
  }

  maxReached(line: Line) {
    return this.getMaxQuantity(line.merchandise) > -1 && this.getMaxQuantity(line.merchandise) <= line.quantity;
  }

  getFinalUnitPriceAmount(line: Line) {
    return line.cost.totalAmount.amount / line.quantity;
  }

  getMaxQuantity(productVariant: Merchandise): number {
    // check with variant options
    if (!productVariant || !productVariant.availableForSale) {
      return -1;
    }
    // If keep selling even if out of stock
    if (productVariant.quantityAvailable === 0 && productVariant.availableForSale) {
      return -1;
    }
    return productVariant.quantityAvailable;
  }

  get discountLabels() {
    return this.line.discountAllocations.map(a => ({ ...a, title: a?.title || a?.code }));
  }
}
